import { ButtonDropdownItem, F0ButtonProps } from '@factorialco/f0-react'
import {
  ArrowRight as ArrowRightIcon,
  CheckCircleLine as CheckCircleLineIcon,
  CheckDouble as CheckDoubleIcon,
  Cross as CrossIcon,
} from '@factorialco/f0-react/icons/app'
import { TasksValueObjectsTaskStatusEnum } from 'generated/resources/datatable.graphql'
import { TasksValueObjectsTaskKindEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

type Action = Pick<F0ButtonProps, 'icon' | 'label'> & {
  id: string
}

type DropdownActions = ButtonDropdownItem<string>[]

type GetTaskActions = (params: {
  taskKind: TasksValueObjectsTaskKindEnum
  status?: TasksValueObjectsTaskStatusEnum
  approvableTypename?: string
}) => {
  primaryAction?: Action
  secondaryAction?: Action
  dropdownActions?: DropdownActions
}

const DefaultIcon = ArrowRightIcon

export const getTaskActions: GetTaskActions = ({ taskKind, status, approvableTypename }) => {
  if (taskKind === 'manual') {
    return {
      dropdownActions: [
        {
          value: 'mark-as-done',
          label: i18n.t('tasks.mark.done'),
          icon: CheckCircleLineIcon,
        },
        status !== 'todo' && {
          value: 'mark-as-todo',
          label: i18n.t('tasks.mark.as', { status: i18n.t('tasks.status.todo').toLowerCase() }),
        },
        status !== 'in_progress' && {
          value: 'mark-as-in-progress',
          label: i18n.t('tasks.mark.as', {
            status: i18n.t('tasks.status.in_progress').toLowerCase(),
          }),
        },
        {
          value: 'mark-as-discarded',
          label: i18n.t('tasks.mark.as', {
            status: i18n.t('tasks.status.discarded').toLowerCase(),
          }),
        },
      ].filter(Boolean),
    }
  }

  // prevent showing actions for discarded and done tasks. Only manual tasks can be discarded or marked as done.
  if (status && ['discarded', 'done'].includes(status)) {
    return {
      primaryAction: undefined,
    }
  }

  switch (taskKind) {
    case 'approve':
      return {
        primaryAction: {
          id: 'approve',
          label: i18n.t('common.approve'),
          icon: CheckDoubleIcon,
        },
        dropdownActions: approvableTypename && approvableTypename === 'ProcurementPurchaseRequest' ? [
          {
            value: 'changes_requested',
                label: i18n.t('procurement.purchase_requests.status.changes_requested'),
                icon: DefaultIcon,
              },
            ]
          : [],
        secondaryAction: {
          id: 'reject',
          label: i18n.t('common.reject'),
          icon: CrossIcon,
        },
      }
    case 'fill':
    case 'complete':
      return {
        primaryAction: {
          id: 'complete',
          label: i18n.t('common.complete'),
          icon: DefaultIcon,
        },
      }
    case 'import':
      return {
        primaryAction: {
          id: 'import',
          label: i18n.t('common.import_only'),
          icon: DefaultIcon,
        },
      }
    case 'send':
      return {
        primaryAction: {
          id: 'send',
          label: i18n.t('common.send'),
          icon: DefaultIcon,
        },
      }
    case 'sign':
      return {
        primaryAction: {
          id: 'sign',
          label: i18n.t('common.sign'),
          icon: DefaultIcon,
        },
      }
    case 'terminate':
      return {
        primaryAction: {
          id: 'terminate',
          label: i18n.t('common.terminate'),
          icon: DefaultIcon,
        },
      }
    case 'upload':
      return {
        primaryAction: {
          id: 'upload',
          label: i18n.t('common.upload'),
          icon: DefaultIcon,
        },
      }
    default:
      return {}
  }
}
